"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.addAdministratorFormFields = exports.addPublisherFormFields = exports.addPublisherSchema = void 0;
const zod_1 = require("zod");
const error_messages_1 = require("@Const/error-messages");
const error_messages_2 = require("@Entities/schemas/work/error-messages");
const validate_1 = require("@App/helpers/validate");
const form_field_types_1 = require("@App/enum/form-field-types");
const populate_schema_1 = __importDefault(require("@App/forms/v2/helpers/populate-schema"));
const publisherNameKey = 'publisherName';
const publisherNameLabel = 'Publisher Name';
const administratorNameLabel = 'Administrator Name';
const ipiNumberKey = 'ipiNumber';
const ipiNumberLabel = 'IPI Number';
const addPublisherSchema = zod_1.z.object({
    [publisherNameKey]: zod_1.z
        .string({
        required_error: error_messages_1.REQUIRED_MESSAGE,
        invalid_type_error: error_messages_1.REQUIRED_MESSAGE,
    })
        .max(200, (0, error_messages_2.stringSizeMaxMessage)('Publisher Name', 200))
        .min(1, error_messages_1.REQUIRED_MESSAGE),
    [ipiNumberKey]: zod_1.z
        .string({
        required_error: error_messages_1.REQUIRED_MESSAGE,
        invalid_type_error: error_messages_1.REQUIRED_MESSAGE,
    })
        .max(200, (0, error_messages_2.stringSizeMaxMessage)('IPI', 11))
        .min(1, error_messages_1.REQUIRED_MESSAGE)
        .refine((ipiNumber) => (0, validate_1.IPIValidator)(ipiNumber, false), 'Invalid IPI Number'),
});
exports.addPublisherSchema = addPublisherSchema;
const addPublisherFormFieldsNoSchema = {
    [publisherNameKey]: {
        name: publisherNameKey,
        label: publisherNameLabel,
        type: form_field_types_1.FormFieldTypes.TEXT,
    },
    [ipiNumberKey]: {
        name: ipiNumberKey,
        label: ipiNumberLabel,
        type: form_field_types_1.FormFieldTypes.TEXT,
    },
};
const addAdministratorFormFieldsNoSchema = {
    [publisherNameKey]: {
        name: publisherNameKey,
        label: administratorNameLabel,
        type: form_field_types_1.FormFieldTypes.TEXT,
    },
    [ipiNumberKey]: {
        name: ipiNumberKey,
        label: ipiNumberLabel,
        type: form_field_types_1.FormFieldTypes.TEXT,
    },
};
const addPublisherFormFields = (0, populate_schema_1.default)(addPublisherFormFieldsNoSchema, addPublisherSchema);
exports.addPublisherFormFields = addPublisherFormFields;
const addAdministratorFormFields = (0, populate_schema_1.default)(addAdministratorFormFieldsNoSchema, addPublisherSchema);
exports.addAdministratorFormFields = addAdministratorFormFields;
